<!--
  ~ Copyright © 2025 Gavin Sawyer. All rights reserved.
  -->

@if (authenticationService.hasWebAuthn$()) {<bowstring--form (output)="signupWithPasskeyFormSubmit(sheetComponentInput$()?.openModel$);">
  <bowstring--text-field-input
    autocomplete="email"
    [formControl]="signupWithPasskeyFormGroup.controls.email"
    i18n-placeholder
    level="2"
    placeholder="email"
    type="email" />
  <bowstring--button
    appearance="raised"
    [disabled]="signupWithPasskeyFormGroup.invalid || signupWithPasskeyFormWorking$()"
    level="2"
    material="inverse"
    type="submit">
    <bowstring--symbol input="PersonBadgeKeyFill" />
    @if (signupWithPasskeyFormWorking$()) {<span><span i18n>working</span>{{ ellipsesService.ellipses$() }}</span>} @else {<bowstring--label
      i18n-input
      input="Save passkey" />}
  </bowstring--button>
  <bowstring--caption i18n>Click <span style="white-space: nowrap;">&ldquo;<bowstring--symbol
    inline
    input="PersonBadgeKeyFill" />&nbsp;<bowstring--label
    i18n-input
    inline
    input="Save passkey" />&rdquo;</span> and present either biometric verification or an external security key in the next step.</bowstring--caption>
</bowstring--form>
  <bowstring--divider />}
<bowstring--form (output)="signupWithPasswordFormSubmit(sheetComponentInput$()?.openModel$);">
  <bowstring--section>
    <bowstring--text-field-input
      autocomplete="email"
      enterKeyHint="next"
      [formControl]="signupWithPasswordFormGroup.controls.email"
      i18n-placeholder
      level="2"
      (nextFocused)="passwordTextFieldInputComponent.focus();"
      placeholder="email"
      type="email" />
    <bowstring--text-field-input #passwordTextFieldInputComponent
      autocomplete="new-password"
      enterKeyHint="next"
      [formControl]="signupWithPasswordFormGroup.controls.password"
      i18n-placeholder
      level="2"
      (nextFocused)="confirmPasswordTextFieldInputComponent.focus();"
      placeholder="password"
      type="password" />
    <bowstring--text-field-input #confirmPasswordTextFieldInputComponent
      autocomplete="new-password"
      [formControl]="signupWithPasswordFormGroup.controls.passwordConfirmation"
      i18n-placeholder
      level="2"
      placeholder="confirm password"
      type="password" />
  </bowstring--section>
  <bowstring--flexbox-container
    alignItems="center"
    flexDirection="row"
    justifyContent="space-between">
    <bowstring--list inline><bowstring--link
      *bowstringListItem
      inline
      (output)="sheetComponentInput$()?.openModel$?.set(false);"
      url="/privacy">
      <bowstring--label
        i18n-input
        input="privacy policy" />
    </bowstring--link><bowstring--link
      *bowstringListItem
      inline
      (output)="sheetComponentInput$()?.openModel$?.set(false);"
      url="/terms">
      <bowstring--label
        i18n-input
        input="terms" />
    </bowstring--link></bowstring--list>
    <bowstring--button
      appearance="symbol"
      [disabled]="signupWithPasswordFormGroup.invalid || signupWithPasswordFormWorking$()"
      type="submit">
      <bowstring--symbol input="ArrowForwardCircleFill" />
    </bowstring--button>
  </bowstring--flexbox-container>
</bowstring--form>
